/* eslint no-console: ["error", { allow: ["log"] }] */
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import ReduxPromise from 'redux-promise' // middleware
import ReduxThunk from 'redux-thunk' // used to fire other actions sequentially
import 'globals/axios' // Axios config
import LeadGenContainer from 'containers/LeadGen'
import CheckoutContainer from 'containers/Checkout'
import QantasFrequentFlyerContainer from 'containers/QantasFrequentFlyer'
import BGAnimation from 'components/BGAnimation'
import trackingMiddleware from 'containers/Checkout/middleware'
import PlanDisplay from 'components/PlanDisplay'
import BrandedButton from 'components/BrandedButton'
import { ENABLE_DEV_TOOLS } from 'globals/constants'

import reducers from './reducers'

const middleware = [ReduxThunk, ReduxPromise, trackingMiddleware]
const consoleStyle = 'background: #555; color: #bada55;'

let devToolsExtension = f => f // Initialise as an empty function

if (ENABLE_DEV_TOOLS === true) {
  console.log('%c_____ PROJECT HAS REDUX TOOLS ENABLED _____', consoleStyle)
  // eslint-disable-next-line no-underscore-dangle
  devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
}

const contactFormElement = document.querySelector('.app__container--lead_gen')
const bgAnimationElement = document.querySelector('.app__container--bg_animation')
const checkoutElement = document.getElementById('app__container--checkout')
const planElements = document.querySelectorAll('.app__container--plan')
const qffElement = document.querySelector('.app__container--qff')
const brandedButtonElements = document.querySelectorAll('.app__element--branded_button')
const homepagePlanDisplay = document.querySelector('#homepage-plan-display')

const middlewareComposed = compose(
  applyMiddleware(...middleware),
  devToolsExtension
)
const store = createStore(reducers, middlewareComposed)
const bootstrapProps = window.bootstrapData || {}
if (contactFormElement) {
  // Contact form embedded in marketing pages (eg. homepage)
  ReactDOM.render(
    <Provider store={store}>
      <LeadGenContainer store={store} {...bootstrapProps} />
    </Provider>,
    contactFormElement
  )
}

if (checkoutElement) {
  // Checkout Application
  ReactDOM.render(
    <Provider store={store}>
      <CheckoutContainer store={store} {...bootstrapProps} />
    </Provider>,
    checkoutElement
  )
}

if (qffElement) {
  // QFF Application
  ReactDOM.render(
    <Provider store={store}>
      <QantasFrequentFlyerContainer store={store} {...bootstrapProps} />
    </Provider>,
    qffElement
  )
}

if (bgAnimationElement) {
  // React Background Animation
  ReactDOM.render(<BGAnimation />, bgAnimationElement)
}

if (brandedButtonElements) {
  // Kogan Branded Button
  const onClick = (target) => {
    if (target) {
      window.location.href = target
    }
  }
  brandedButtonElements.forEach((button) => {
    const text = button.getAttribute('data-label')
    const targetUrl = button.getAttribute('data-target')
    ReactDOM.render(<BrandedButton fitContent labelText={text} onClick={() => onClick(targetUrl)} />, button)
  })
}

if (homepagePlanDisplay && window.bootstrapPlans) {
  const plans = Object.values(window.bootstrapPlans)
  const buttonTexts = Array(...planElements).map(element => element.getAttribute('data-button-text'))
  const onButtonClicks = Array(...planElements).map(element =>
    function redirect() {
      document.location.href = element.getAttribute('data-redirect-target')
    })
  ReactDOM.render(
    <PlanDisplay plans={plans} buttonTexts={buttonTexts} onButtonClicks={onButtonClicks} />,
    homepagePlanDisplay
  )
}



// WEBPACK FOOTER //
// ./index.jsx